module.exports = __webpack_public_path__ + "img/product_103.cad0fce.webp";